import { Component, Prop, Vue } from 'vue-property-decorator';
import { buildListEmoji } from '@/helpers';
import { EmojiRate } from '@/models';
import EmotionIcon from '@/components/common/emotion-icon/EmotionIcon.vue';
import Tooltip from '@/components/common/tooltip/Tooltip.vue';

@Component({
  components: {
    EmojiCharacteristicBar,
    EmotionIcon,
    Tooltip
  }
})
export default class EmojiCharacteristicBar extends Vue {
  @Prop({}) characteristic: string;
  @Prop({}) characteristicTooltip: string;
  @Prop({}) ratingPoint: number;

  get listEmoji(): EmojiRate[] {
    return this.buildListEmoji();
  }

  buildListEmoji(): EmojiRate[] {
    const resultList = buildListEmoji(false);
    if (this.ratingPoint) {
      resultList[this.ratingPoint - 1].isActive = true;
    }
    return resultList;
  }

  getRatingPoint(selectedEmoji: EmojiRate): void {
    this.$emit('onEmojiRateChange', { emojiRated: selectedEmoji, character: this.characteristic });
  }
}
